module.exports = __webpack_public_path__ + "img/logo.69b652cd.svg";